import { supabase } from '../supabaseClient';

/* Accès aux données « profiles ». Chaque fonction renvoie la requête Supabase telle quelle
   (à attendre par l'appelant) : aucune logique métier ici. */

export function fetchProfile(userId) {
  return supabase.from('profiles').select('*').eq('id', userId).single();
}

export function linkProfileToMember(userId) {
  return supabase.from('profiles').update({ dev_id: userId }).eq('id', userId);
}

export function fetchMembers() {
  return supabase
    .from('profiles')
    .select(
      'id,nom,role,taux_contrat,cout_horaire,dev_id,archived_at,jours_travailles,is_planifiable,color,solde_cp,email,type_contrat,created_at,date_fin_contrat,is_conges_validator',
    )
    .not('nom', 'is', null)
    .order('id');
}

export function setLeaveBalance(devId, n) {
  return supabase
    .from('profiles')
    .update({ solde_cp: n, solde_cp_updated_at: new Date().toISOString() })
    .eq('id', devId);
}

export function fetchProfiles() {
  return supabase.from('profiles').select('*').order('nom').order('id');
}

export function setupNewProfile(devId, newUserForm, tauxContrat) {
  return supabase
    .from('profiles')
    .update({
      dev_id: devId,
      taux_contrat: tauxContrat,
      cout_horaire: parseFloat(newUserForm.coutHoraire) || 0,
      jours_travailles: newUserForm.joursTravailles || [],
      type_contrat: newUserForm.typeContrat || 'CDI',
      is_conges_validator: newUserForm.isCongesValidator === true,
    })
    .eq('id', devId);
}

export function deleteProfile(userId) {
  return supabase.from('profiles').delete().eq('id', userId);
}

export function setProfileArchived(archive, u) {
  return supabase
    .from('profiles')
    .update({ archived_at: archive ? new Date().toISOString() : null })
    .eq('id', u.id);
}
